if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      // メイン画像は.product__media-item.is-activeの中のimgを取得
      this.mainSlider = this.querySelector('[id^="Slider-Gallery-"]');
      // サムネイルは.thumbnailクラスを持つbuttonを取得
      this.thumbnails = this.querySelectorAll('button.thumbnail');
      
      if (!this.mainSlider || !this.thumbnails.length) return;

      this.thumbnails.forEach(thumbnail => {
        thumbnail.addEventListener('click', (e) => {
          e.preventDefault();
          
          // サムネイルのアクティブ状態を更新
          this.thumbnails.forEach(t => t.removeAttribute('aria-current'));
          thumbnail.setAttribute('aria-current', 'true');
          
// メイン画像を更新
const targetId = thumbnail.closest('li').dataset.target;
          
// 現在アクティブなスライドからis-activeを削除
const currentActive = this.mainSlider.querySelector('.is-active');
if (currentActive) {
  currentActive.classList.remove('is-active');
}

// 新しいスライドをアクティブに
const targetSlide = this.mainSlider.querySelector(`[data-media-id="${targetId}"]`);
if (targetSlide) {
  targetSlide.classList.add('is-active');
}
});
});
}
});
}